/**
 * SOLID Review
 * S — Strong. 21 lines, one job: the IEntitySuccess/IEntityFailure discriminated union and its two constructors (ok/
 *     fail).
 * O — Strong. A new Result variant would require touching this file, but no such change has ever been
 *     needed — the two-case union is complete for its purpose.
 * L — N/A — no inheritance hierarchy (plain type aliases + factory functions).
 * I — Strong. ok/fail are used independently by different callers; nothing is forced on a consumer that
 *     only needs one.
 * D — Strong. Zero imports.
 */
export type IEntityFailure = {
  readonly success: false;
  readonly error: Error;
};

export type IEntitySuccess<T> = {
  readonly success: true;
  readonly value: T;
};

export type Result<T> = IEntitySuccess<T> | IEntityFailure;

export const ok = <T>(value: T): IEntitySuccess<T> => ({
  success: true,
  value,
});

export const fail = (error: Error): IEntityFailure => ({
  success: false,
  error,
});
